"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sassano": {
    "ffc2fdf1": [{
      "hkey": "b4ce4640",
      "slug": "silla",
      "name": "Silla",
      "primary": true,
      "skipSearch": false
    }],
    "borgate-silla": [{
      "hkey": "b4ce4640",
      "slug": "silla",
      "name": "Silla",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f64f3b54": [{
      "hkey": "be28e111",
      "slug": "sassano",
      "name": "Sassano",
      "primary": true,
      "skipSearch": false
    }],
    "peglio": [{
      "hkey": "be28e111",
      "slug": "sassano",
      "name": "Sassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a90164e": [{
      "hkey": "be28e111",
      "slug": "sassano",
      "name": "Sassano",
      "primary": true,
      "skipSearch": false
    }],
    "san-rocco": [{
      "hkey": "be28e111",
      "slug": "sassano",
      "name": "Sassano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;